<template>
    <component :is="component" :theme="theme"/>
</template>

<script>
import {
    markRaw,
} from 'vue';

export default {
    name: 'TemplateRoutes',
    data() {
        return {
            view: '-',
            vue: undefined,
        };
    },
    computed: {
        component() {
            this.fetch_component();
            return this.vue;
        },
        theme() {
            return this.$router.theme;
        },
    },
    methods: {
        fetch_component() {
            const payload = this.$router.payload;
            const view = payload.view;

            if (!this.$api.authorized) {
                if (view !== 'login') {
                    if (this.$api.accounts.length > 0) {
                        const redirect_uri = this.$router.href(payload);
                        setTimeout(() => {
                            this.$router.push({
                                view: 'login',
                                mode: 'switch',
                                redirect_uri,
                            });
                        }, 0);
                    } else if (this.$api.autologin) {
                        const redirect_uri = this.$router.href(payload);
                        setTimeout(() => {
                            this.$router.push({
                                view: 'login',
                                redirect_uri,
                            });
                        }, 0);
                    }
                }
            }

            if (view !== this.view) {
                this.view = view;
                const component = this.$router.component();
                if (typeof component === 'function') {
                    this.vue = undefined; // loading
                    component().then((module) => {
                        this.vue = markRaw(module.default);
                    });
                } else {
                    this.vue = markRaw(component);
                }
            }
        },
    },
    mounted() {
        window.onfocus = () => {
            // setTimeout(() => {
            //     if (this.$api.authorized) {
            //         const accounts = this.$api.accounts;
            //         if (accounts.length > 0) {
            //             let account = accounts[0];
            //             this.$api.login(account)
            //                 .then(user => {
            //                     account.user = user;
            //                     this.$api.store.accounts = accounts;
            //                     this.$api.save_accounts();
            //                 })
            //                 .catch(e => {
            //                     this.$api.handle_authorization_activation(true);
            //                     console.log(e);
            //                 })
            //         }
            //     }
            // }, 500);
        };
    },
};
</script>

<style>
html {
    font-family: "Ubuntu", "Roboto", sans-serif !important;
    font-size: 14px !important;
}
body {
  background: rgb(var(--v-theme-surface));
}
.mdi:before, .mdi-set {
    font-size: 24px !important;
}
::-webkit-scrollbar {
    height: 6px;
    width: 6px;
}

::-webkit-scrollbar-track-piece {
    background: rgba(var(--v-theme-surface));
}

::-webkit-scrollbar-thumb {
    background: rgba(var(--v-theme-on-surface-variant));
    border-radius: 4px;
}
</style>
